import { render } from "./LoaderScreen.vue?vue&type=template&id=399f61dc&scoped=true&ts=true"
import script from "./LoaderScreen.vue?vue&type=script&lang=ts"
export * from "./LoaderScreen.vue?vue&type=script&lang=ts"

import "./LoaderScreen.vue?vue&type=style&index=0&id=399f61dc&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399f61dc"]])

export default __exports__